import { Module } from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { State } from '@/main/store'
import { CityDataInitialState } from './types'

const cityStore: Module<CityDataInitialState, State> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default cityStore
